import { render } from "./SupplierLedger.vue?vue&type=template&id=72c7e519&scoped=true"
import script from "./SupplierLedger.vue?vue&type=script&lang=js"
export * from "./SupplierLedger.vue?vue&type=script&lang=js"

import "./SupplierLedger.vue?vue&type=style&index=0&id=72c7e519&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c7e519"]])

export default __exports__